import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { Breadcrumb } from 'aui';
import { FoxIconRightSm } from 'aui-biz-icons';
import clsx from 'clsx';
import styles from './DocsBreadcrumb.module.css';

export type DocsBreadcrumbProps = {
  className?: string;
};

export function DocsBreadcrumb(props: DocsBreadcrumbProps) {
  const { className } = props;

  const parentSidebarTreeApiFolderNodes = useDocsDataModelStore(
    (x) => x.sidebarTree.parentSidebarTreeApiFolderNodes,
  );

  if (!parentSidebarTreeApiFolderNodes.length) {
    return null;
  }
  return (
    <Breadcrumb
      separator={<FoxIconRightSm className="align-middle" size={14} />}
      className={clsx('text-[14px] leading-base', styles['docs-breadcrumb'], className)}
    >
      {parentSidebarTreeApiFolderNodes.map((x) => {
        return <Breadcrumb.Item key={x.key}>{x.name}</Breadcrumb.Item>;
      })}
    </Breadcrumb>
  );
}
